import { Observable } from "rxjs/Observable";

/**
 * This implementation is problematic because in a later version of rxjs it's deprecated.
 * So the use in future version (v7.0) is like this:
 * ```typescript
 * return firstValueFrom(
 *   of(0).pipe(
 *     withLatestFrom(this.wish$),
 *     map((tuple) => tuple[1]),
 *     take(1)
 *   )
 * );
 * ```
 */
export const observableToPromise = <T>(
  _observable: Observable<T>
): Promise<T> => {
  return _observable.toPromise();
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/utils/observableToPromise.ts